document.addEventListener("DOMContentLoaded", () => {
  // notify弹出弹窗
  $(".anni5-pre-order .product-notify-btn").click(function () {
    $(".anni5-pre-order .notify-window").css("display", "flex");
  });

  //  弹窗关闭按钮
  $(".anni5-pre-order .close-icon").click(function () {
    $(this).parent(".notify-window").css("display", "none");
  });

  // code copy
  $(".anni5-pre-order .code-wrapper .copy-btn").click(function () {
    let code = $(this).parent().find(".code-text").text();
    let nodeEl = $(this);
    navigator.clipboard
      .writeText(code)
      .then(function () {
        nodeEl.html('<svg viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 5.5L5 9.5L13 1.5" stroke="#000" stroke-width="1.5"/></svg>');
        setTimeout(function () {
          nodeEl.text("COPY");
        }, 3000);
      })
      .catch((err) => {
        alert("copy error!");
      });
  });

  // 价格汇率
  const priceElements = document.querySelectorAll('.anni5-pre-order [data-format="true"]');
  priceElements.forEach((item) => {
    const discountPrice = item.querySelector('.discount-price').dataset.price;
    const originalPrice = item.querySelector('.original-price').dataset.price;

    const formattedDiscountPrice = currencyFormatter.formats.formatMoney(
      discountPrice * Shopify.currency.rate,
      window.moneyFormat.format_with_currency
    );
    const formattedOriginalPrice = currencyFormatter.formats.formatMoney(
      originalPrice * Shopify.currency.rate,
      window.moneyFormat.format_with_currency
    );

    item.querySelector('.discount-price').textContent = formattedDiscountPrice;
    item.querySelector('.original-price').textContent = formattedOriginalPrice;
  })
});
